import { jumpHandle } from "./axiosUrl"
//栏目id列表
export const channelIdList = {
    channelImages: '17e17d3a-213e-4594-a6b3-0ea4c64ed900',//轮播图
    notice: '388ca960-c27c-472f-9822-a3527debdbd7',//通知
    publicity: 'b9929ded-cc42-41b7-a4f8-3403b968f539',//公示
    countryFile: '7c4c34b4-847f-417e-9e3c-25ce4c7d0d2c'//国务院文件
}
// export const homeQuickEntry = [
//     { value: 'onlineService', label: '在线办事', icon: 'el-icon-date', path: '/admin-license' },
//     { value: 'officeQuery', label: '办件查询', icon: 'el-icon-search', path: '/handle_result' },
//     // { value: 'serviceRating', label: '服务评价', icon: 'el-icon-edit', extendIcon: 'el-icon-download', extendMethod: '', extendLabel: '表格下载', name: `${jumpAddress}` },
//     { value: 'serviceRating', label: '服务评价', icon: 'el-icon-edit',name: `${jumpHandle}`},
//     { value: 'illegalReport', label: '违法举报', icon: 'el-icon-message', name: 'http://jb.ncha.gov.cn/tBTipoffFrontendController.do?tBTipoffMainIndex' }

// ]
export const homeCheckList = [
    { value: 'listOfServiceItems', label: '办事事项目录清单', icon: 'el-icon-date', path: "/admin-license" },
    { value: 'listOfRegulatoryMatters', label: '监管事项目录清单', icon: 'el-icon-search', path: "/industry-manage" },
]
export const informationInquiryList = [
    { value: 'immovableCulturalRelics', label: '不可移动文物' },
    { value: 'museumsAndCollections', label: '博物馆和馆藏文物' },
    { value: 'socialCulturalRelics', label: '社会文物' },
    { value: 'revolutionaryArtifacts', label: '革命文物' },
    { value: 'IndustryQualification', label: '行业资质' }
]
export const immovableCulturalRelicsList = [
    { id: 1, title: '中国历史文化名城名单', icon: 'iconlvyouchengshijianzhucity-changanjiestreet', icon_class: 'changan-street', path: "/Industry/Famous-historical", type: 'cityName' },
    { id: 2, title: '中国历史文化名镇名单', icon: 'iconlvyoujianzhumingshenggujitourism-yandaoshenshe', icon_class: 'famous-town', path: "/Industry/Famous-historical", type: 'townName' },
    { id: 3, title: '中国历史文化名村名单', icon: 'iconnongcunshenghuowuran30', icon_class: 'village', path: "/Industry/Famous-historical", type: 'villageName' },
    { id: 4, title: '中国历史文化街区名单', icon: 'icondc-icon-shengjigaoxinjishuqiyeyanjiukaifazhongxin', icon_class: 'street', path: "/Industry/Famous-historical", type: 'streetName' },
    { id: 5, title: '中国世界文化遗产名录', icon: 'iconchangcheng', icon_class: 'great-wall', path: "/Industry/World-Heritage" },
    { id: 6, title: '全国重点文物保护单位名单', icon: 'iconjianzhuquan', icon_class: 'sunbird', path: "/Industry/National-cultural" },
]
export const museumsAndCollectionsList = [
    { id: 1, title: '全国博物馆名录', icon: 'iconjianzhu', icon_class: 'building', path: "/Industry/Collection-unit" },
    { id: 2, title: '全国珍贵文物数据库', icon: 'iconziyuan3', icon_class: 'archives', path: "/Industry/Collection-Collection" },
]
export const socialCulturalRelicsList = [
    { id: 1, title: '国家文物进出境审核管理处名单', icon: 'iconwenwuyijiao', icon_class: 'artifacts-transfer', path: "/Industry/Entry-exit", only: 1 },
    { id: 2, title: '全国文物商店、文物拍卖企业名单', icon: 'iconshangdian', icon_class: 'shop', path: "/Industry/Cultural-auction", only: 1 },
    { id: 3, title: '涉案文物鉴定评估机构名单', icon: 'icondaishouquan', icon_class: 'person-card', path: "/Industry/Cultural-relics", only: 1 },
    { id: 4, title: '中国被盗文物信息发布平台', icon: 'iconditu', icon_class: 'china', path: "#", only: 1,url:"http://bdww.ncha.gov.cn/" },
    { id: 5, title: '外国被盗文物数据库', icon: 'icondiqiu-', icon_class: 'abroad', path: "/Industry/foreign-cultural", only: 1 },
    { id: 6, title: '上海市民间收藏文物鉴定咨询推荐单位名单', icon: 'iconshanghai', icon_class: 'shanghai-flag', path: "/Industry/Consultation-sh", only: 1 },
    { id: 7, title: '民间收藏文物鉴定试点单位名单', icon: 'icondc-icon-shengjigaoxinjishuqiyeyanjiukaifazhongxin', icon_class: 'survey-design', path: "/Industry/Folk-collection", only: 1 },
]
export const revolutionaryArtifactsList = [
    { id: 1, title: '革命文物保护利用片区分县名单', icon: 'icondangwugongkai', icon_class: 'party-flag', path: '/Industry/Revolution-Relic', only: 1, name: 'Revolution-Relic' },
]
export const IndustryQualificationList = [
    { id: 1, title: '全国文物保护工程资质单位数据库', icon: 'iconzizhirenzheng', icon_class: 'zizhi', path: '/Industry/cul-protection-unit-info', only: 1 },
    { id: 2, title: '全国文物保护工程资格人员数据库', icon: 'iconqunzu', icon_class: 'group', path: '/Industry/industry-supervision-management-search', only: 1 },
]
export const officePublic = [
    { value: 'PublicityOfOfficeResults', label: '办件结果公开', icon: 'el-icon-date', path: '/handle_result' },
    { value: 'RegulatoryInformationDisclosure', label: '监管信息公开', icon: 'el-icon-search', path: '/enforce-notice' },
]
export const IndustryRegulation = [
    { value: 'lawsRegulations', label: '法律法规', icon: 'el-icon-date', path: "/policy" },
    { value: 'standardSpecification', label: '标准规范', icon: 'el-icon-search', path: "/standard" },
]
export const processing = [
    { value: 'whole', label: '全部' },
    { value: 'culturalRelicsProtection', label: '文物保护' },
    { value: 'archaeologicalExcavation', label: '考古发掘' },
    { value: 'museumManagement', label: '博物馆管理' },
    { value: 'culturalRelics', label: '文物进出境' }
]
export const exhibition = [
    { value: 'museum', label: '博物馆网上展厅', icon_class: "building" ,href:"http://virtual.vizen.cn/"},
    { value: 'brilliantAchievements', label: '辉煌成就网上展馆', icon_class: "guohui",href:"http://guoqing70.cctv.com/" },
    { value: 'artifactsOfTheRevolution', label: '革命文物数字展厅', icon_class: "party-flag" ,href:"http://webapp.vizen.cn/redchina/index.html"},
    { value: 'irrelevantToTheSubject', label: '文博网络学院', icon_class: "archives" ,href:"http://edu.ncha.gov.cn/index.do"},
]
export const informationInquiry = {
    immovableCulturalRelics: immovableCulturalRelicsList,
    museumsAndCollections: museumsAndCollectionsList,
    socialCulturalRelics: socialCulturalRelicsList,
    revolutionaryArtifacts: revolutionaryArtifactsList,
    IndustryQualification: IndustryQualificationList
}
